var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NewsTemplate"},[_c('Header'),_c('div',{staticClass:"mainWrap"},[_c('Main',[_c('News')],1)],1),_c('Footer',{attrs:{"noImage":"","id":"footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }